import { cn } from '~lib/utils/style';

import { Typography } from '~ui/base/typography';

const EXAMPLES = ['climate', 'protein', 'environmental'];

interface ExampleQueriesProps {
  onSelect: (query: string) => void;
  className?: string;
}

/** Clickable example queries below the search input — DESIGN.md §13. */
function ExampleQueries({ onSelect, className }: ExampleQueriesProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-3 gap-y-2', className)}>
      <Typography variant="caption-md" as="span" className="text-muted-foreground">
        Try
      </Typography>
      {EXAMPLES.map((example) => (
        <button
          key={example}
          type="button"
          onClick={() => onSelect(example)}
          className={cn(
            'rounded-full px-3 py-1 text-xs font-medium tracking-wide text-primary-dark',
            'transition-colors hover:bg-accent hover:text-primary',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          )}
        >
          {example}
        </button>
      ))}
    </div>
  );
}

export { ExampleQueries };
